<template>
  <div>
    <p class="input-text-size common-decal-message">{{ message }}</p>
  <v-data-table :headers="headers" :items="editeditems"
  class="hide-footer-select elevation-1 input-text-size"
  hide-default-footer>
    <template v-slot:item="{ item }">
      <tr>
        <td>{{ item.taxYear }}</td>
        <td>{{ item.taxId }}</td>
        <td>{{ propertyTaxTypeName(item.propertyTaxType) }}</td>
        <td>{{ item.ownerName }}</td>
        <td class="text-end">{{ amountFormat(item.mobileHome) }}</td>
        <td>{{ item.mhVin }}</td>
        <td>{{ item.currentDecal }}</td>
        <td>
          <v-text-field v-model="item.mhDecal" dense hide-details
            class="input-text-size common-decal-input"
            :label="`Decal # for ${item.taxYear} / ${item.taxId}`" />
        </td>
      </tr>
    </template>
  </v-data-table>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { CommonDecalDialogHeaders } from '../paymentutils/PaymentTransactionTableHeaders';
import { propertyTaxTypeName } from '../../../../util/shared/tmc-global';
import { amountFormat } from '../../../../util/shared/vue-global';

export default {
  name: 'CommonDecalDialog',
  data() {
    return {
      headers: CommonDecalDialogHeaders,
      baseCrudKey: 'ComhDecalmmonDecalDialogCrudKey',
    };
  },
  computed: {
    ...mapGetters('base/crud', ['items']),
    editeditems: {
      get() {
        return this.items(this.baseCrudKey);
      },
      set(value) {
        this.setItems([this.baseCrudKey, value]);
      },
    },
    // Says which record(s) the decal number will be saved on. The prompt opens for every line on
    // the payment with a mobile home value - real estate records included - so a bare "this tax
    // record has a mobile home" read as "this payment has a mobile home" (McIntosh TKT-000992).
    message() {
      const rows = this.editeditems || [];
      if (!rows.length) return '';
      if (rows.length > 1) {
        return 'These records on this payment have a mobile home. If you are issuing a decal for one, '
          + 'enter the decal number on that record\'s line below.';
      }
      const { taxYear, taxId, propertyTaxType } = rows[0];
      const type = propertyTaxTypeName(propertyTaxType);
      return `${taxYear} Tax ID ${taxId}${type ? ` (${type})` : ''} has a mobile home. `
        + 'If you are issuing a decal for it, enter the decal number below.';
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setIsVisible', 'setItem']),
    propertyTaxTypeName,
    amountFormat,
  },
};
</script>

<style scoped>
/* wide enough for the whole "Decal # for 2026 / 1234567" label, which is what tells the clerk
   which record the number goes on */
.common-decal-input {
  min-width: 14rem;
}
</style>
